import { render, staticRenderFns } from "./Marketing.vue?vue&type=template&id=6d806e52&scoped=true&"
import script from "./Marketing.vue?vue&type=script&lang=js&"
export * from "./Marketing.vue?vue&type=script&lang=js&"
import style0 from "./Marketing.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Marketing.vue?vue&type=style&index=1&id=6d806e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d806e52",
  null
  
)

export default component.exports